import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const Plus = ({ height, width, fill, className }) => {
  return (
    <svg
      id="plus"
      width={width}
      height={height}
      fill={fill}
      stroke="none"
      className={className}
      viewBox="0 0 21 21"
      xmlns="http://www.w3.org/2000/svg"
    >
        <path fillRule="evenodd" clipRule="evenodd" d="M10.7818 -0.00012207H10.218C9.45703 -0.00012207 8.84333 0.61579 8.84333 1.37498V8.84196H0.999632C0.448282 8.84196 -0.000793457 9.28975 -0.000793457 9.84218V11.1581C-0.000793457 11.7101 0.448282 12.1579 0.999632 12.1579H8.84333V19.6249C8.84333 20.3845 9.45703 21 10.218 21H10.7818C11.5427 21 12.1589 20.3845 12.1589 19.6249V12.1579H20.0001C20.5515 12.1579 21.0005 11.7101 21.0005 11.1581V9.84218C21.0005 9.28975 20.5515 8.84196 20.0001 8.84196H12.1589V1.37498C12.1589 0.61579 11.5427 -0.00012207 10.7818 -0.00012207Z"/>
    </svg>
  );
};
/* eslint-enable max-len */
Plus.defaultProps = {
  className: null,
};

Plus.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  fill: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default Plus;
